import { Section, SectionHeader, PrimaryButton } from "@/components/Section";
import { SEO } from "@/components/SEO";
import { portfolio } from "@/config/site";

export default function Portfolio() {
    return (
        <>
            <SEO title="Realizacje – Szymkas Agency" description="Projekty stron internetowych, aplikacji, brandingu i social media." />
            <section className="bg-[#06111F] text-white pt-32 pb-16 md:pt-40 md:pb-20 relative overflow-hidden">
                <div className="absolute inset-0 bg-grid-faint opacity-50" />
                <div className="relative max-w-4xl mx-auto px-5 md:px-8 text-center">
                    <div className="text-xs font-semibold tracking-widest uppercase text-[#14B8A6] mb-3">Realizacje</div>
                    <h1 className="font-display font-extrabold text-[38px] md:text-[58px] lg:text-[64px] leading-[1.05] tracking-tight">
                        Projektujemy rozwiązania,<br /><span className="text-[#14B8A6]">nie tylko ładne grafiki</span>
                    </h1>
                    <p className="mt-6 text-[#AAB6C5] text-base md:text-lg max-w-2xl mx-auto">
                        Każda realizacja rozpoczyna się od poznania problemu, odbiorców i celu biznesowego.
                    </p>
                </div>
            </section>
            <Section variant="light">
                <div className="space-y-16 md:space-y-24">
                    {portfolio.map((c, idx) => (
                        <div key={c.slug} className={`grid lg:grid-cols-2 gap-10 items-center ${idx % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`} data-testid={`portfolio-detail-${c.slug}`}>
                            <div>
                                <div className="aspect-[16/10] rounded-[20px] bg-gradient-to-br from-[#0F172A] to-[#06111F] relative overflow-hidden border border-[#E5E7EB]">
                                    <div className="absolute inset-0 bg-grid-faint opacity-50" />
                                    <div className="absolute inset-0 flex items-center justify-center p-8">
                                        <div className="w-full max-w-md rounded-md bg-white/10 border border-white/20 backdrop-blur-sm p-5">
                                            <div className="flex items-center justify-between mb-3">
                                                <div className="flex gap-1.5">
                                                    <span className="w-2 h-2 rounded-full bg-white/30" />
                                                    <span className="w-2 h-2 rounded-full bg-white/30" />
                                                    <span className="w-2 h-2 rounded-full bg-white/30" />
                                                </div>
                                                <div className="h-1.5 w-12 bg-[#14B8A6] rounded-full" />
                                            </div>
                                            <div className="h-2 w-2/3 bg-white/30 rounded mb-2" />
                                            <div className="h-1.5 w-3/4 bg-white/20 rounded mb-1" />
                                            <div className="h-1.5 w-1/2 bg-white/20 rounded mb-4" />
                                            <div className="grid grid-cols-3 gap-2">
                                                <div className="aspect-square rounded bg-[#14B8A6]/30" />
                                                <div className="aspect-square rounded bg-white/10" />
                                                <div className="aspect-square rounded bg-white/10" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="text-xs font-semibold tracking-widest uppercase text-[#14B8A6] mb-3">{c.category}</div>
                                <h2 className="font-display font-bold text-[28px] md:text-[36px] leading-tight text-[#0B1220]">{c.title}</h2>
                                <div className="mt-6 space-y-4">
                                    <div>
                                        <h3 className="font-semibold text-sm uppercase tracking-wider text-[#0B1220]/60 mb-1">Problem</h3>
                                        <p className="text-[#0B1220]/80 leading-relaxed">{c.problem}</p>
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-sm uppercase tracking-wider text-[#0B1220]/60 mb-1">Rozwiązanie</h3>
                                        <p className="text-[#0B1220]/80 leading-relaxed">{c.solution}</p>
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-sm uppercase tracking-wider text-[#0B1220]/60 mb-2">Zakres</h3>
                                        <div className="flex flex-wrap gap-2">
                                            {c.scope.map((s) => (
                                                <span key={s} className="px-3 py-1 rounded-full bg-[#14B8A6]/10 text-[#0EA5A5] text-xs font-semibold">{s}</span>
                                            ))}
                                        </div>
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-sm uppercase tracking-wider text-[#0B1220]/60 mb-1">Rezultat</h3>
                                        <p className="text-[#0B1220]/80 leading-relaxed">{c.result}</p>
                                    </div>
                                    {c.concept && (
                                        <p className="text-[11px] text-[#0B1220]/40 italic pt-2">Projekt koncepcyjny przygotowany na potrzeby portfolio.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="mt-16 text-center">
                    <PrimaryButton to="/kontakt" testid="portfolio-cta">Opowiedz nam o projekcie</PrimaryButton>
                </div>
            </Section>
        </>
    );
}
